import clearInput from '../components/clear-input';
import { $, loading, dataExist, svg, translationGuard } from '../utils/Utils';
import endPoint from '../utils/end-points';
import Event from '../utils/Event';
import { Accordion } from './accordion';

require('es6-promise').polyfill();
const axios = require('axios');

const searchFaq = (() => {
  const config = {
    triggers: [...$('.js-searchFaqTrigger')],
    triggerCN: 'js-searchFaqTrigger',
    form: [...$('.js-searchFaqForm')],
    target: $('.js-searchFaqTarget')[0],
    faqSelected: $('.js-faqSelected')[0],
    tags: $('.js-searchFaqTags')[0],
    categories: '.js-searchFaqCategory',
    title: $('.js-searchFaqTitle')[0],
    requestDelta: 600,
  };

  let lastData;
  let lastQuery = '';
  let isTyping = false;
  let timeToken = false;

  const clearRequest = () => {
    clearTimeout(timeToken);
    timeToken = false;
  };

  const createMarkup = {
    tags({ data }) {
      return `
        <li class="listTags__listItem">
          <label for="search-c-0" class="listTags__label">
            <input type="checkbox" name="search-c" id="search-c-0" class="listTags__checkbox js-searchFaqCategory" data-category="0" checked>
            <span class="listTags__tag"><span class="listTags__effect">All kategorier</span> <span class="listTags__count">(${data.totalCount})</span></span>
          </label>
        </li>
        ${data.categories.map((category, i) => `
          <li class="listTags__listItem">
            <label for="search-c-${i + 1}" class="listTags__label">
              <input type="checkbox" name="search-c" id="search-c-${i + 1}" class="listTags__checkbox js-searchFaqCategory" data-category="${category.id}">
              <span class="listTags__tag"><span class="listTags__effect">${translationGuard(category.name)}</span> <span class="listTags__count">(${category.count})</span></span>
            </label>
          </li>
        `).join('')}
      `;
    },
    results(categories) {
      return `
        <div id="faq-list" class="accordion -faq -bullet">
          ${categories.map(category => `
            ${category.posts.map(post => `
              <div class="accordion__item">
                <h3>
                  <button class="accordion__trigger"
                    type="button"
                    aria-expanded="false"
                    aria-controls="${'faq-list-target-'+post.id}"
                    id="${'faq-list-trigger-'+post.id}"
                  >
                    <span class="accordion__title">
                      ${(dataExist(post, 'title')) ? post.title : ''}
                    </span>
                  </button>
                </h3>
                <div id="${'faq-list-target-'+post.id}"
                  role="region"
                  aria-labelledby="${'faq-list-trigger-'+post.id}"
                  class="accordion__panel fm" hidden
                >
                  ${(dataExist(post, 'content')) ? post.content : ''}
                </div>
              </div>
            `).join('')}
          `).join('')}
        </div>`;
    },
  };

  const handleResults = ({
    categories, val, sorting,
  }) => {
    if(config.faqSelected) {
      if(sorting || val)
        config.faqSelected.classList.remove('-expanded');
      else
        config.faqSelected.classList.add('-expanded');
    }
    // update title
    config.title.textContent = `Vanliga frågor ${(val) ? `för ”${val}"` : ''} ${(sorting) ? `i kategori${(categories.length > 1) ? 'erna' : 'n'} ”${categories.map(category => `${category.name}`).join(', ')}"` : 'i alla kategorier'}`;
    // show title
    config.title.classList.remove('-hide');
    // show & update result markup
    config.target.innerHTML = createMarkup.results(categories);
    config.target.querySelectorAll('.accordion .accordion__item').forEach((accordionEl) => {
      new Accordion(accordionEl);
    });
  };

  const handleCategorySorting = ({ IDs, reset }) => {
    // get the value of the input
    const input = config.triggers[0];
    let val = input.value.trim();
    // check if value is empty or not
    val = (val !== '') ? val : false;

    // check if selecting a specific category or if clicked on All categories
    if (!reset) {
      // make a copy of vault to iterate on
      const carbon = Object.assign({}, lastData);
      const sorting = true;
      // update carbon with categories to show only
      carbon.categories = IDs.map(ID => carbon.categories.filter(category => category.id === ID)[0]);
      handleResults({
        categories: carbon.categories, val, sorting,
      });
    } else {
      // make a copy of lastData to iterate on
      const carbon = Object.assign({}, lastData);
      handleResults({ categories: carbon.categories, val });
    }
  };

  const handleCategoryChange = ({ trigger, triggers }) => {
    const ID = parseFloat(trigger.dataset.category);
    const t = trigger;
    const ts = triggers;
    let reset = false;

    // check which category has been clicked on
    if (ID === 0) {
      // once ticking all categories, untick all other categories
      // get all categories except 'all categories'
      const catsExceptTrigger = ts.filter(category => category !== t);
      // untick them all
      catsExceptTrigger.forEach(category => category.checked = false);

      // can't unticked all categories
      if (!t.checked) {
        t.checked = true;
      }
      // needed for templating
      reset = true;
    } else {
      // all categories except 'All categories'
      const catsExceptAll = ts.filter(category => parseFloat(category.dataset.category) !== 0 && category.checked);
      // 'All categories' category
      const allCats = ts.filter(category => parseFloat(category.dataset.category) === 0)[0];

      if (catsExceptAll.length > 0) {
        // at least one is ticked
        // make sure 'All categories' gets unticked when clicking on something else
        if (allCats.checked) {
          allCats.checked = false;
        }
      } else {
        // everything got unticked, so tick 'All categories'
        allCats.checked = true;
        // needed for templating
        reset = true;
      }
    }

    // get the IDs of ticked categories
    const tickedCatsID = ts
      .filter(category => category.checked === true)
      .map(item => parseFloat(item.dataset.category));

    handleCategorySorting({ IDs: tickedCatsID, reset });
  };

  const handleTagsEvent = () => {
    const triggers = [...$(config.categories)];

    triggers.forEach((trigger) => {
      trigger.addEventListener('change', () => handleCategoryChange({ trigger, triggers }));
    });
  };

  const handleTags = ({ data }) => {
    config.tags.innerHTML = createMarkup.tags({ data });
    // handle event after new tags are added to the DOM
    handleTagsEvent();
  };

  const handleResponse = ({ data, val }) => {
    handleTags({ data });
    handleResults({ categories: data.categories, val });
  };

  const fetchData = ({ val }) => {
    loading.show([config.target, config.tags]);

    // hide title
    config.title.classList.add('-hide');

    axios
      .get(`${endPoint.faq}/search?term=${val}`)
      .then((response) => {
        if (response.status === 200) {
          loading.stop([config.target, config.tags]);
          handleResponse({ data: response.data, val });
          lastData = response.data;
        }
      });
  };

  const storeData = () => {
    axios
      .get(`${endPoint.faq}/withPosts/`)
      .then((response) => {
        if (response.status === 200) {
          // this is the very first
          lastData = response.data;
        }
      });
  };

  const toggleClearButton = ({ val, trigger }) => {
    (val.length > 0) ? clearInput.show(trigger) : clearInput.hide(trigger);

    // event is emitted when the (X) is clicked
    Event.on('clearInput', () => {
      // cancel axios request
      clearRequest();

      // Send keyup to reload content
      const ev = new KeyboardEvent('keyup', {
        code: 'Backspace',
        key: 'Backspace',
        type: 'keyup',
      });
      trigger.dispatchEvent(ev);

      // focus on the input
      trigger.focus();
    });
  };

  const keyUpGuard = (e) => {
    switch (e.keyCode) {
      case 16: // shift
      case 91: // cmd
      case 17: // ctrl
      case 18: // alt
      case 9: // tab
      case 32: // space -> unecessary to do request for a space
      case 33:
      case 34:
      case 35:
      case 36:
      case 20: // shift lock
        return false;
        break;
      default:
        return true;
        break;
    }
  };

  const handleKeyUp = ({ e, trigger }) => {
    // prevent some of the keys to trigger the function
    if (!keyUpGuard(e)) return false;
    const val = trigger.value.trim();

    // avoid unneccessary AJAX calls
    if (val !== lastQuery) {
      toggleClearButton({ val, trigger });

      if (isTyping) {
        clearRequest();
      } else {
        isTyping = true;
      }

      if (!timeToken) {
        timeToken = setTimeout(() => {
          clearRequest();
          isTyping = false;
          fetchData({ val });
          lastQuery = val;
        }, config.requestDelta);
      }
    } else {
      clearRequest();
    }
  };

  const handleSubmit = ({ e, form }) => {
    e.preventDefault();
    handleKeyUp({ e, trigger: form.querySelector(`.${config.triggerCN}`) });
  };

  const build = () => {
    handleTagsEvent();

    if (config.form.length > 0) {
      config.form.forEach((form) => {
        form.addEventListener('submit', e => handleSubmit({ e, form }));
      });
    }

    config.triggers.forEach((trigger) => {
      trigger.addEventListener('keyup', e => handleKeyUp({ e, trigger }));
    });
  };

  const init = () => {
    if (config.triggers.length > 0) {
      build();
      storeData();
      clearInput.init();
    }
  };

  return {
    init,
    stop: clearRequest,
  };
})();

export default searchFaq.init();
